import http from '../../base/api/public.js'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre

export default {
  // 会员
  getCardTypes() {
    return http.requestGet(apiPre + service.member + '/member/memberEnum/cardTypeValues', {})
  },
  getCardBelongType() {
    return http.requestGet(apiPre + service.member + '/member/memberEnum/cardBelongType', {})
  },
  getCardStates() {
    return http.requestGet(apiPre + service.member + '/member/memberEnum/cardStateValues', {})
  },
  getChecked() {
    return http.requestGet(apiPre + service.member + '/member/memberEnum/checkedValues', {})
  },
  getCustomerLevel() {
    return http.requestGet(apiPre + service.member + '/member/memberEnum/customerLevelValues', {})
  },
  getIntegrationAuthState() {
    return http.requestGet(apiPre + service.member + '/member/memberEnum/IntegrationAuthStateEnum', {})
  },
  // 会员 end
  getPaymentType() {
    return http.requestGet(apiPre + service.order + '/order/orderEnum/payTypeEnum', {})
  },
  getParamCode() {
    return http.requestGet(apiPre + service.pay + '/paramEnum/queryEnum', {})
  },
  getPayment() {
    return http.requestGet(apiPre + service.pay + '/paramEnum/paymentTypeEnum', {})
  },
  getPayRequestReource() {
    return http.requestGet(apiPre + service.pay + '/paramEnum/requestSourceEnum', {})
  },
  getRoleTypes() {
    return http.requestGet(apiPre + service.rbac + '/rbac/enum/roleTypes', {})
  },
  getOrderStatus() {
    return http.requestGet(apiPre + service.order + '/order/orderEnum/orderStatus', {})
  },
  getPayStatus() {
    return http.requestGet(apiPre + service.order + '/order/orderEnum/payStatus', {})
  },
  getPayChannelEnum() {
    return http.requestGet(apiPre + service.order + '/order/orderEnum/PayChannelEnum', {})
  },
  getTradeTypeEnum() {
    return http.requestGet(apiPre + service.order + '/order/orderEnum/TradeTypeEnum', {})
  },
  getPayWayEnum() {
    return http.requestGet(apiPre + service.order + '/order/orderEnum/PayWayEnum', {})
  },
  getRefundTypeEnum() {
    return http.requestGet(apiPre + service.order + '/order/orderEnum/RefundTypeEnum', {})
  },
  getRequestSource(){
    return http.requestGet(apiPre + service.order + '/order/orderEnum/RequestSourceEnum',{})
  },
  getCardRechargeTypeEnum(){
    return http.requestGet(apiPre + service.order + '/order/orderEnum/CardRechargeTypeEnum',{})
  },
  //发票抬头枚举
  getTitleType() {
    return http.requestGet(apiPre + service.order + '/order/orderEnum/InvoiceTitleEnum', {})
  },
  getMemberAppType() {
    return http.requestGet(apiPre + service.member + '/member/memberEnum/appTypeEnumValues', {})
  },
  getWalletMode() {
    return http.requestGet(apiPre + service.member + '/member/memberEnum/groupWalletModeValues', {})
  },
  getCouponType() {
    return http.requestGet(apiPre + service.member + '/member/memberEnum/couponTypeValues', {})
  },
  //广告点击事件类型
  getClickEventType(){
    return http.requestGet(apiPre + service.member + '/member/memberEnum/clickEventTypeValues', {})
  },
  //广告状态类型
  getStateType(){
    return http.requestGet(apiPre + service.member + '/member/memberEnum/advertStateValues', {})
  },
  //广告展示位类型
  getPositionType(){
    return http.requestGet(apiPre + service.member + '/member/memberEnum/positionTypeValues', {})
  },
  //广告素材类型
  getMaterialType(){
    return http.requestGet(apiPre + service.member + '/member/memberEnum/materialTypeValues', {})
  },
  //公告状态类型
  getNoticeStateType(){
    return http.requestGet(apiPre + service.member + '/member/memberEnum/noticeStateValues', {})
  },


  /*运维服务Enum*/
  //远程控制类型
  getCommandType() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/commandType', {})
  },
  //评价星级
  getPraiseLevel() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/praiseLevel', {})
  },
  //评价审核状态
  getPraiseState() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/praiseState', {})
  },
  //告警等级
  getAlarmLevel() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/alarmLevel', {})
  },
  //告警状态
  getAlarmState() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/alarmState', {})
  },
  //告警类型
  getAlarmType() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/alarmType', {})
  },
  //桩厂商协议
  getPileProtocol() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/pileProtocol', {})
  },
  //告警通知方式
  getAlarmNoticeWay() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/noticeWay', {})
  },
  //故障处理状态
  getFaultRepairState() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/faultRepairState', {})
  },
  //故障报修类别
  getFaultType() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/faultType', {})
  },
  /*售后服务*/
  getSaleOrderState() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/saleOrderState', {})
  },
  getSaleType() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/saleType', {})
  },
  //参数类型
  getParamType() {
    return http.requestGet(apiPre + service.ops + '/ops/opsEnum/paramType', {})
  },



  // 结算服务枚举
  getGroupRepaymentState() {
    return http.requestGet(apiPre + service.sett + '/settlement/enum/groupRepaymentState', {})
  },
  getCommissionTradeType() {
    return http.requestGet(apiPre + service.sett + '/settlement/enum/commissionTradeType', {})
  },
  getSettlementTypeEnum() {
    return http.requestGet(apiPre + service.sett + '/settlement/enum/SettlementTypeEnum', {})
  },
  // 钱包退款相关枚举
  getWalletRefundOrderStateEnum() {
    return http.requestGet(apiPre + service.order + '/order/orderEnum/WalletRefundOrderStateEnum', {})
  },
  //支付渠道类别
  getPayChannelTypeEnum() {
    return http.requestGet(apiPre + service.order + '/order/orderEnum/payChannelTypeEnum', {})
  }

}



// WEBPACK FOOTER //
// ./src/common/api/enumApi.js